import React from 'react';
import { Route } from 'react-router-dom';
import Courses from '@/pages/master-settings/Courses';
import Semesters from '@/pages/master-settings/Semesters';
import Sections from '@/pages/master-settings/Sections';
import FeeStructures from '@/pages/master-settings/FeeStructures';
import Discounts from '@/pages/master-settings/Discounts';
import Scholarships from '@/pages/master-settings/Scholarships';
import TaxManagement from '@/pages/master-settings/TaxManagement';
import FineSetting from '@/pages/master-settings/FineSetting';
import OtherFees from '@/pages/master-settings/OtherFees';
import Languages from '@/pages/master-settings/Languages';
import Religions from '@/pages/master-settings/Religions';
import Castes from '@/pages/master-settings/Castes';
import Subjects from '@/pages/master-settings/Subjects';
import MethodSubjects from '@/pages/master-settings/MethodSubjects';
import ReceiptTerms from '@/pages/master-settings/ReceiptTerms';
import Sessions from '@/pages/master-settings/Sessions';
import Classrooms from '@/pages/master-settings/Classrooms';
import Departments from '@/pages/master-settings/Departments';
import Designations from '@/pages/master-settings/Designations';
import Holidays from '@/pages/master-settings/Holidays';
import WorkingDays from '@/pages/master-settings/WorkingDays';
import AttendanceFine from '@/pages/master-settings/AttendanceFine';
import SalaryComponents from '@/pages/master/SalaryComponents';
import WithdrawalPolicySettings from '@/pages/settings/WithdrawalPolicySettings';
import DateTimeSettings from '@/pages/master-settings/DateTimeSettings';

export const masterSettingsRoutes = (
  <React.Fragment>
    <Route path="master-settings/courses" element={<Courses />} />
    <Route path="master-settings/salary-components" element={<SalaryComponents />} />
    <Route path="master-settings/semesters" element={<Semesters />} />
    <Route path="master-settings/sections" element={<Sections />} />
    <Route path="master-settings/fee-structures" element={<FeeStructures />} />
    <Route path="master-settings/discounts" element={<Discounts />} />
    <Route path="master-settings/scholarships" element={<Scholarships />} />
    <Route path="master-settings/tax-management" element={<TaxManagement />} />
    <Route path="master-settings/fine-setting" element={<FineSetting />} />
    <Route path="master-settings/other-fees" element={<OtherFees />} />
    <Route path="master-settings/languages" element={<Languages />} />
    <Route path="master-settings/religions" element={<Religions />} />
    <Route path="master-settings/castes" element={<Castes />} />
    <Route path="master-settings/subjects" element={<Subjects />} />
    <Route path="master-settings/method-subjects" element={<MethodSubjects />} />
    <Route path="master-settings/receipt-terms" element={<ReceiptTerms />} />
    <Route path="master-settings/sessions" element={<Sessions />} />
    <Route path="master-settings/classrooms" element={<Classrooms />} />
    <Route path="master-settings/departments" element={<Departments />} />
    <Route path="master-settings/designations" element={<Designations />} />
    <Route path="master-settings/holidays" element={<Holidays />} />
    <Route path="master-settings/working-days" element={<WorkingDays />} />
    <Route path="master-settings/attendance-fine" element={<AttendanceFine />} />
    <Route path="master-settings/withdrawal-policy" element={<WithdrawalPolicySettings />} />
    <Route path="master-settings/date-time-settings" element={<DateTimeSettings />} />
  </React.Fragment>
);
